import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import {ListItem,ListItemText,Collapse} from '@material-ui/core';
import { Alert,Card,Row,Col } from 'react-bootstrap';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import JadwalForm from './JadwalHwForm';

class JadwalHomework extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isLoading: false,
            isFetching: false,
            isLoadJadwal: false,
            isAddEditJadwal: false,            
            alertShow: false,
            openDialog: false,
            resMessage: '',
            params: {},
            listHw: [],  
            listJadwal: [],
            selectedJadwal: {},
            selectedProfil: {},
        };
    }

    async componentDidMount() {
        document.title = "Jadwal Homework";
        this.setState({ isFetching: true});
        await this.props.cekCookies();    
        if(!__.isEmpty(this.props.account)) {
            this.setState({
                params: {
                    idSekolah: this.props.account.idSekolah,
                    idGuru: this.props.account.idGuru,
                    search: null 
                }
            })
            this.fetchHw();
        } 
        this.setState({ isFetching: false});   
    }

    fetchHw = async() => {
        this.setState({ isLoading: true, listHw:[] });
        const res = await accountManagement.get(CONFIG.HW_LIST ,{
            params: this.state.params
        }).catch(function(error){ console.log(error) });
        
        if (res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ listHw: res.data.data });  
            } else {
                this.setState({ listHw: [] });  
            }
            
            this.setState({ isLoading: false});          
        }
        this.setState({ isLoading: false });
    }

    searchJadwal = async(value) => {
        this.setState({ isLoadJadwal: true, listJadwal: [] }) 
        this.setState(state => ({
            ...state,
            listHw: state.listHw.map(item =>
              item.idProfilCbt === value.idProfilCbt ? { ...item, open: !value.open } : { ...item, open: false }
            )
        }));

        if(!value.open) {
            this.setState({ isLoadJadwal: true, listJadwal: [] })           

            const response = await accountManagement.get(CONFIG.EXAM_GET_JADWAL_BY_IDPROFIL+ value.idProfilCbt).catch (function(error){ alert(error) })            

            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        listJadwal: response.data.data
                    })    
                }   
                this.setState({isLoadJadwal: false});            
            }        
        }  
    }

    addEditJadwal = async(profil, jadwal) => {
        this.setState({ 
            isAddEditJadwal: true,
            alertShow: false, 
            selectedProfil: profil,
            selectedJadwal: jadwal
        }); 
    }   

    submitJadwal = async(dataSend) => {
        this.setState({isFetching: true })
        const response = await accountManagement.post(CONFIG.EXAM_JADWAL_SAVE, dataSend)
        .catch(function(error){ console.log(error) });
        const {listJadwal} = this.state;
        if(response) {    
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){   
                this.setState({ 
                    listJadwal: listJadwal.filter(jadwal => jadwal.idJadwal !== dataSend.idJadwal),                
                });
                this.setState(prevState => ({
                    listJadwal: [...prevState.listJadwal, response.data.data]
                })); 
                this.setState({isAddEditJadwal: false})  
                //document.getElementById('col-parent-'+ response.data.data.idProfil).classList.add('show');
            }
            this.setState({                
                resMessage: response.data.errorSchema.errorMessage,                
                isFetching: false,
                alertShow: true
            })            
        }
    }

    deleteJadwal = async(id) => {
        this.setState({isFetching: true, openDialog:false })
        const response = await accountManagement.post(CONFIG.EXAM_JADWAL_DELETE + id)
        .catch(function(error){ alert(error) });
        const {listJadwal} = this.state;
        if(response) {    
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){   
                this.setState({ 
                    listJadwal: listJadwal.filter(jadwal => jadwal.idJadwal !== id),                
                });                
            }
            this.setState({                
                resMessage: response.data.errorSchema.errorMessage,                
                isFetching: false,
                alertShow: true
            })            
        }
    }

    handleBack = () => {
        this.setState({ isAddEditJadwal: false })
    }

    render() {
        const {isAddEditJadwal,listHw, listJadwal, selectedJadwal, selectedProfil} = this.state;
        let formJadwal;        
        
        if(isAddEditJadwal) {
            formJadwal = <JadwalForm submitJadwal={this.submitJadwal} jadwal={selectedJadwal} profil={selectedProfil} handleBack={this.handleBack} />
        }
        
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/> 
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Penjadwalan Homework'}/> 
                    {this.loadAlert()} 
                    {!isAddEditJadwal &&
                    <div className="container-fluid"> 
                        <div className="row">  
                            <div className="col-sm-6 ">&nbsp;</div>
                            <div className="col-sm-6 ">
                                <input type="text" className="form-control pull-right" style={{width:'60%'}} placeholder="search jadwal ..." 
                                    onKeyUp={this.handleSearch} />
                            </div>

                        </div>
                        {this.loading()}
                        {!this.state.isLoading &&
                        <div className="mt-2">      
                            {listHw.map((data, i) =>
                            <Card style={{marginBottom:'5px'}} key={i}>
                                <Row>
                                    <Col sm={4}>
                                    <ListItem button onClick={() => this.searchJadwal(data)}>       
                                        {i+1}.                         
                                        <ListItemText inset primary={data.namaProfil}/>
                                        {data.open ? <ExpandLess /> : <ExpandMore />}      
                                    </ListItem>
                                    </Col>

                                    <Col sm={3} style={{margin: 'auto'}}>
                                        <ListItemText  primary={data.namaSubProfil} />   
                                    </Col>

                                    <Col sm={2} style={{margin: 'auto'}}>
                                        <ListItemText  primary={data.namaKelas} />   
                                    </Col>

                                    <Col sm={1} style={{margin: 'auto'}}>
                                        <small>{data.jumlahSoal} Soal </small>
                                    </Col>

                                    <Col sm={2} style={{margin: 'auto'}}>
                                        <button className="btn btn-outline-primary btn-sm" onClick={() => this.addEditJadwal(data, {} )}>
                                            <i className="fa fa-calendar-o" aria-hidden="true"></i> add Jadwal
                                        </button>   
                                    </Col>
                                </Row>

                                {data.open && this.state.isLoadJadwal ? <Loader /> : 
                                <Collapse timeout="auto" unmountOnExit style={{margin: '0 20px'}} in={data.open}>
                                    {listJadwal.map((jadwal, i) =>
                                    <Card border="info" style={{marginBottom:'5px'}} key={i}>                                        
                                            <Row>                                                
                                                <Col sm={3}>
                                                    <ListItem>       
                                                        <span>{i+1}.</span>                             
                                                        <ListItemText inset primary={jadwal.namaJadwal} />  
                                                    </ListItem>
                                                </Col>
                                                <Col sm={4} style={{margin: 'auto'}}>
                                                    <small>Jadwal: {jadwal.jadwalMulai} s/d {jadwal.jadwalSelesai} </small>  
                                                </Col>  

                                                <Col sm={3} style={{margin: 'auto'}}>
                                                    <small>Report: {jadwal.jadwalReport}</small>  
                                                </Col>   

                                                <Col sm={2} style={{margin: 'auto'}}>
                                                    <div className="button-group text-center">                                        
                                                        <button className="btn btn-warning btn-sm" title="Edit" 
                                                            onClick={() => this.addEditJadwal(data, jadwal )}>
                                                            <i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>&nbsp;
                                                        <button onClick={() => this.handleDialog(jadwal)} 
                                                            className="btn btn-danger btn-sm" title="Hapus">
                                                            <i className="fa fa-trash" aria-hidden="true"></i></button>										
                                                    </div>
                                                </Col>                                                       
                                            </Row> 
                                    </Card>  
                                )}
                                </Collapse>    
                                }
                            </Card>                            
                            )}   
                        </div> 
                        }
                    </div>
                    }  
                    
                    {formJadwal}               
                    {this.confirmDialog()}
                    
                </div>
                
            </div> 
        );
    }

    loading = () =>{
        if(this.state.isLoading){
            return(
                <Loader />
            )
        }
    }
    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }  

    handleDialog = (data) => {
        this.setState({
            openDialog: true,
            selectedJadwal: data
        })
    }

    confirmDialog() {        
        const {openDialog, selectedJadwal} = this.state;  
        const handleClose = () => { this.setState({openDialog: false, selectedJadwal: {} }) };        
        return (            
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Perhatian !!</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">                        
                        Yakin akan menghapus Jadwal <strong>{selectedJadwal.namaJadwal}</strong> ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-danger" onClick={handleClose}> Tidak </button>
                    <button className="btn btn-success" onClick={() => this.deleteJadwal(selectedJadwal.idJadwal)} autoFocus> Ya </button>                  
                </DialogActions>
            </Dialog>            
        )
    }  
}
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(JadwalHomework); 
